/**
 * Image save protection: no right-click menu or dragging on images. A deterrent only; it cannot stop
 * screenshots or developer tools. Off in the theme editor.
 */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const isImage = (target) => target instanceof Element && target.closest('img, picture, svg image');
  document.addEventListener('contextmenu', (event) => {
    if (isImage(event.target)) event.preventDefault();
  }, true);
  document.addEventListener('dragstart', (event) => {
    if (isImage(event.target)) event.preventDefault();
  }, true);
})();
